module.exports = __webpack_public_path__ + "img/brand-daihatsu.0c055865.png";